import React from 'react';
import { Card, CardBody, Col, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Contact, Hometxt, Modalcontent, Profile, TabsWithIcon } from '../../../../../Constant';
import { P } from '../../../../../AbstractElements';
import HeaderCard from '../../../../Common/HeaderCard';
import TabsPreventDefaultAndAnimation from '../../../../../Hoc/TabsPreventDefaultAndAnimation';

const WithIcon = ({ show, tabActive, tabActiveHandler }) => {
  return (
    <Col sm='12' xl='6 xl-100'>
      <Card>
        <HeaderCard title={TabsWithIcon} />
        <CardBody>
          <Nav className='nav nav-tabs nav-bottom m-b-30'>
            <NavItem>
              <NavLink href='#javascript' className={tabActive === '1' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '1')}>
                <i className='icofont icofont-ui-home'></i>
                {Hometxt}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href='#javascript' className={tabActive === '2' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '2')}>
                <i className='icofont icofont-man-in-glasses'></i>
                {Profile}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href='#javascript' className={tabActive === '3' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '3')}>
                <i className='icofont icofont-contacts'></i>
                {Contact}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={tabActive}>
            <TabPane className={`fade ${tabActive === '1' ? show : ''}`} tabId='1'>
              <P className='mb-0'>{Modalcontent}</P>
            </TabPane>
            <TabPane className={`fade ${tabActive === '2' ? show : ''}`} tabId='2'>
              <P className='mb-0'>{Modalcontent}</P>
            </TabPane>
            <TabPane className={`fade ${tabActive === '3' ? show : ''}`} tabId='3'>
              <P className='mb-0'>{Modalcontent}</P>
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TabsPreventDefaultAndAnimation(WithIcon);
